{
  "el": {
    "reminder": {
      "actions": {
        "cancel": "Ακύρωση",
        "edit": "Επεξεργασία",
        "hideReminders": "Απόκρυψη υπενθυμίσεων",
        "save": "Αποθήκευση",
        "showReminders": "Εμφάνιση υπενθυμίσεων"
      },
      "contactType": {
        "customer": "Πελάτης",
        "partner": "Συνεργάτης"
      },
      "labels": {
        "after": "μετά",
        "before": "πριν",
        "click": "Κάνε κλικ εδώ για να ορίσεις υπενθύμιση",
        "date": "στις {date}",
        "dateAfterDueDate": "Μετά την προθεσμία",
        "dateAlreadyPassed": "η ημερομηνία έχει ήδη περάσει",
        "decisionApprovedNotSent": "Η απόφαση έχει ληφθεί. Οι υπενθυμίσεις που βρίσκονταν ακόμη σε αναμονή ακυρώθηκαν.",
        "dueDate": "την προθεσμία",
        "editTitle": "Επεξεργασία υπενθυμίσεων",
        "here": "εδώ",
        "infoReminders": "Οι υπενθυμίσεις είναι ενεργές μόνο για δόσεις που έχουν ορισμένη προθεσμία.",
        "noReminderSet": "Δεν έχει οριστεί υπενθύμιση",
        "reminder": "Υπενθύμιση",
        "reminders": "Υπενθυμίσεις",
        "remindersCustomer": "Υπενθυμίσεις για τον πελάτη σου",
        "remindersPartners": "Υπενθυμίσεις για τους συνεργάτες",
        "reminders_count": "{count} υπενθύμιση ορισμένη | {count} υπενθυμίσεις ορισμένες",
        "sendOnDeadline": "Η υπενθύμιση θα σταλεί κατά την προθεσμία",
        "sendReminder": "Αποστολή υπενθύμισης",
        "sent_at": "Η υπενθύμιση στάλθηκε στις {date}",
        "warningReminders": "Αυτή η ενέργεια αντικαθιστά και τις 4 υπενθυμίσεις. Κάθε υπενθύμιση που αφήσεις κενή εδώ θα αφαιρεθεί από κάθε απόφαση."
      },
      "toasts": {
        "update": "Η υπενθύμιση ενημερώθηκε με επιτυχία"
      }
    }
  }
}
